import styled from 'styled-components'

export const PopupVisibilityUi = styled.div.attrs(() => ({
  'data-testid': 'popup',
}))<{ isVisible: boolean }>`
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
`
